import { Box, Button, Container, Grid, InputAdornment, Stack, TextField, Typography, useMediaQuery } from "@mui/material";
import Kanban from '../../assets/kanban.png';
import { useCallback, useEffect, useMemo, useState } from "react";
import KanbanDisplay from "./components/KanbanDisplay";
import SearchIcon from '@mui/icons-material/Search';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import ListaDisplay from "./components/ListaDisplay";
import useDebounce from "../../lib/useDebounce";
import { useSearch } from "../../contexts/SearchContext";
import useSetParamsURL from "../../lib/useSetParamsURL";
import { FilterList } from "@mui/icons-material";
import DialogFiltrosTarefas from "./components/DialogFiltrosTarefas";
import { TFluxoProcesso } from "../../types/api/geral/fluxo-processo";
import { useModalDetalheProcesso } from "../../components/ModalContexts/ModalDetalheProcessoContext";

export default function Tarefas() {

    const matches = useMediaQuery('(min-width:600px)');
    const { searchParams, setParamsUrl } = useSetParamsURL();
    const { openModal } = useModalDetalheProcesso();

    const [showDisplay, setShowDisplay] = useState<TDisplayValues>("Kanban");
    const [filtrosOpen, setFiltrosOpen] = useState(false)
    const [filtros, setFiltros] = useState<TFiltrosTarefas | null>(null)
    const [keywordPesquisa, setKeywordPesquisa] = useState("")
    const { setSearchTerm } = useSearch();
    const keyword = useDebounce(keywordPesquisa) as string

    const metodosVisualizacao: TMetodosVisualizacao[] = useMemo(() => [
        { label: "Kanban", icon: <ViewKanbanIcon /> },
        { label: "Lista", icon: <FormatListBulletedIcon /> }
    ], [])

    //funcoes manipuladoras
    const handleOpenModalDetail = useCallback((codigo: string) => {
        openModal(codigo)
        setParamsUrl(codigo, 'detalhe-processo')
    }, [openModal, setParamsUrl])
    //

    useEffect(() => {
        const detalheProcesso = searchParams.get('detalhe-processo')
        if (detalheProcesso) {
            openModal(detalheProcesso)
        }
    }, [searchParams, openModal])

    return (
        <>
            <Container>
                <Box mt={3} display="flex" justifyContent="space-between">
                    <Box display="flex" flex={1} flexDirection="column" mr={2}>
                        <Box>
                            <Typography variant="h5">Bem vindo ao seu quadro de tarefas!</Typography>
                            <Typography >Aqui você acompanha todas os processos vinculados ao seu usuário 😃</Typography>
                        </Box>

                        <Grid container spacing={2} mt={0.5} alignItems="flex-end">
                            <Grid size={{ xs: 12, md: 7 }}>
                                <TextField
                                    label="Pesquisar"
                                    variant="outlined"
                                    fullWidth
                                    value={keywordPesquisa}
                                    onChange={(e) => {
                                        setKeywordPesquisa(e.target.value)
                                        setSearchTerm(e.target.value)
                                    }}
                                    slotProps={{
                                        input: {
                                            startAdornment:
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid size={{ xs: 6, md: 2.5 }} direction={'column'}>
                                <Typography variant="caption">Visualizar como:</Typography>
                                <Stack direction={'row'} gap={1}>
                                    {
                                        metodosVisualizacao.map((item, index) => {
                                            const selectItem = item.label === showDisplay

                                            return (
                                                <Button
                                                    key={index}
                                                    size="small"
                                                    startIcon={item.icon}
                                                    variant={selectItem ? "contained" : "outlined"}
                                                    onClick={() => setShowDisplay(item.label)}
                                                >
                                                    {item.label}
                                                </Button>
                                            )
                                        })
                                    }
                                </Stack>
                            </Grid>
                            <Grid size={{ xs: 6, md: 2.5 }} display="flex" justifyContent="flex-end">
                                <Button
                                    sx={{ minWidth: 100 }}
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    endIcon={<FilterList />}
                                    onClick={() => setFiltrosOpen(true)}
                                >
                                    Filtros
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    {
                        matches &&
                        <img width={120} src={Kanban} alt="" />
                    }
                </Box>

                {
                    showDisplay === "Kanban" &&
                    <KanbanDisplay {...{ handleOpenModalDetail, keyword, filtros }} />
                }

                {
                    showDisplay === "Lista" &&
                    <ListaDisplay {...{ handleOpenModalDetail, keyword, filtros }} />
                }
            </Container>

            {
                filtrosOpen &&
                <DialogFiltrosTarefas
                    defFiltros={filtros}
                    open={filtrosOpen}
                    onClose={() => setFiltrosOpen(false)}
                    onApplyFilters={(filtros) => {
                        setFiltros(filtros);
                        setFiltrosOpen(false);
                    }}
                />
            }
        </>
    )
}

type TDisplayValues = "Kanban" | "Lista"

type TMetodosVisualizacao = {
    label: TDisplayValues,
    icon: React.ReactNode
}

export type TFiltrosTarefas = {
    fluxo_contem: TFluxoProcesso[] | null,
}

export type THandleOpenDetailDialog = (arg: string) => void 